import React, { useEffect, useState } from 'react';
import PropType from 'prop-types';

import { ReactComponent as EditIcon } from 'assets/svgs/edit-pen.svg';
import { ReactComponent as CheckMarkIcon } from 'assets/svgs/check-mark-alt.svg';
import { ReactComponent as CloseIcon } from 'assets/svgs/close-x-cancel.svg';
import { messages } from './messages';
import Input from 'ui/Input';
import { translate } from 'utils/index';

import './categroyTabLabel.scss';

const EDIT_ICON_SIZE = 15;
const CLOSE_ICON_SIZE = 12;

const CategoryTabLabel = ({ id, activeTab, text, saveAction }) => {
  const [value, setValue] = useState(text || '');
  const [isEditMode, setEditMode] = useState(false);

  const handleSetValue = (event) => {
    setValue(event.target.value);
  };

  const handleSaveAction = () => {
    saveAction(value);
    setEditing(false);
  };

  const setEditing = (edit) => {
    setEditMode(edit);
  };

  useEffect(() => {
    if (isEditMode && activeTab !== id) {
      setEditing(false);
    }
  }, [activeTab]);

  return (
    <div className="category-tab-label">
      {isEditMode ? (
        <div
          className="category-tab-label__editing"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Input
            data-test="category-tab"
            onChange={handleSetValue}
            value={value}
            size="small"
            placeholder={translate(messages.inputPlaceholder)}
          />{' '}
          <CheckMarkIcon onClick={handleSaveAction} width={15} height={12} />
          <CloseIcon
            onClick={() => setEditing(false)}
            width={CLOSE_ICON_SIZE}
            height={CLOSE_ICON_SIZE}
          />
        </div>
      ) : (
        <>
          {text}
          <EditIcon
            className="category-tab-label__edit-icon"
            onClick={setEditing}
            width={EDIT_ICON_SIZE}
            height={EDIT_ICON_SIZE}
          />
        </>
      )}
    </div>
  );
};

CategoryTabLabel.propTypes = {
  id: PropType.string,
  activeTab: PropType.string,
  text: PropType.string,
  saveAction: PropType.func,
};

export default CategoryTabLabel;
